<template>
  <div>
    <Header />
    <main>
      <section class="shop">
        <i class="fas fa-shield-alt"></i>
        <h1>Contact</h1>
      </section>
      <section class="safety-info">
        <p>If you need help, support, or have any questions, feel free to reach out to us through the following channels:</p>
        <div class="contact-links">
          <a href="https://discord.gg/WbyUDYN9Xd" target="_blank" class="contact-item">
            <i class="fab fa-discord"></i> Join our Discord
          </a>
          <a href="mailto:shoptcontact@gmail.com" class="contact-item">
            <i class="fas fa-envelope"></i> shoptcontact@gmail.com
          </a>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'

export default {
  name: 'Contact',
  components: {
    Header
  },
  metaInfo() {
    return {
      title: "Contact | ShopT"
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
  color: #fff;
}

.safety-info {
  width: 100%;
  max-width: 800px;
  margin-top: 2rem;
  padding: 2rem;
  background-color: #222;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.safety-info p {
  font-size: 1.3rem;
  line-height: 1.8;
  color: #ccc;
  margin-bottom: 2rem;
}

.contact-links {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.contact-item {
  font-size: 1.2rem;
  color: #fff;
  text-decoration: none;
  background-color: #333;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  border: 1px solid #555;
  transition: background 0.3s, transform 0.3s;
}

.contact-item i {
  margin-right: 10px;
  font-size: 1.4rem;
}

.contact-item:hover {
  background-color: cornflowerblue;
  transform: scale(1.05);
  color: #fff;
}

.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
